module.exports = __webpack_public_path__ + "static/img/indian-5882625_960_720.fb2cdf9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/indian-5882625_960_720.webp
// module id = cYDQ
// module chunks = 0